import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { MiraieService } from './miraie.service';

@Injectable({
  providedIn: 'root'
})
export class SearchTopService {

  constructor(
    private http: MiraieService,
    public authService: AuthService,
  ) { }


  //テンプレート一覧の取得
  getTemplateList(authority_code) {
    var url = "searchtemplate/list";

    let param = { 'authority_code': authority_code };

    return this.http.post(url, param);
  }

  //指定テンプレートの取得
  getTemplate(search_condition_code) {
    var url = "searchtemplate/get";

    let param = { 'search_condition_code': search_condition_code };

    return this.http.post(url, param);
  }

  //テンプレートの検索条件取得
  getCondition(search_condition_code, division_code, user_code) {
    var url = "searchtemplate/condition";

    let param = {
      'search_condition_code': search_condition_code,
      'division_code': division_code,
      'user_code': user_code
    };

    return this.http.post(url, param);
  }

  //テンプレートの新規登録
  addTemplate(authority_code, title, search_condition) {
    var url = "searchtemplate/add";

    let param = { 'authority_code': authority_code, 'title': title, 'search_condition': search_condition };

    return this.http.post(url, param);
  }

  //テンプレートの更新
  updateTemplate(search_condition_code, title, search_condition) {
    var url = "searchtemplate/upd";

    let param = { 'search_condition_code': search_condition_code, 'title': title, 'search_condition': search_condition };

    return this.http.post(url, param);
  }

  //テンプレートの削除
  delTemplate(search_condition_code) {
    var url = "searchtemplate/del";

    let param = { 'search_condition_code': search_condition_code };

    return this.http.post(url, param);
  }
}
